import React, { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <style>{`
        *{
          box-sizing:border-box;
        }

        .header{
          display:flex;
          align-items:center;
          justify-content:center;
          position:relative;
          padding:20px 180px;
          background:#fff8e7;
          border-bottom:3px solid #ff8a00;
        }

        .left-logo{
          position:absolute;
          left:20px;
          top:15px;
        }

        .left-logo img{
          width:100px;
        }

        .header-title{
          text-align:center;
        }

        .header-title h2{
          margin:5px 0;
          color:#102542;
        }

        .iso-box{
          display:flex;
          flex-direction:column;
          align-items:center;
          margin-top:10px;
        }

        .iso-box img{
          width:80px;
        }

        .right-images{
          position:absolute;
          right:20px;
          top:15px;
          display:flex;
          gap:10px;
        }

        .right-images img{
          width:75px;
          height:75px;
          border-radius:8px;
          object-fit:cover;
        }

        .style20{
          background:#ff8a00;
          color:white;
          padding:10px;
          overflow:hidden;
        }

        .marquee p{
          margin:0;
          white-space:nowrap;
          animation:marquee 15s linear infinite;
          font-weight:bold;
        }

        @keyframes marquee{
          from{transform:translateX(100%);}
          to{transform:translateX(-100%);}
        }

        .menu-toggle{
          display:none;
          width:100%;
          background:#102542;
          color:white;
          border:none;
          font-size:30px;
          padding:10px;
          cursor:pointer;
        }

        .menuicons{
          background:#102542;
          padding:12px 0;
        }

        .menuicons ul{
          list-style:none;
          display:flex;
          justify-content:center;
          flex-wrap:wrap;
          gap:15px;
          margin:0;
          padding:0;
        }

        .menuicons ul li{
          position:relative;
          background:#ff8a00;
          border-radius:10px;
        }

        .menuicons ul li a,
        .menu-link{
          color:white;
          text-decoration:none;
          padding:10px 18px;
          display:block;
          font-weight:600;
          cursor:pointer;
        }

        .menuicons ul li:hover{
          background:#cc6e00;
        }

        .dropdown-menu{
          display:none;
          position:absolute;
          top:100%;
          left:0;
          min-width:220px;
          background:white;
          border-radius:10px;
          overflow:hidden;
          box-shadow:0 8px 20px rgba(0,0,0,.2);
          z-index:9999;
        }

        .dropdown-menu a{
          color:#102542 !important;
          background:white;
        }

        .dropdown-menu a:hover{
          background:#f4f4f4;
          color:#ff8a00 !important;
        }

        .dropdown:hover .dropdown-menu{
          display:block;
        }

        /* MOBILE */

        @media(max-width:768px){

          .header{
            flex-direction:column;
            padding:15px;
          }

          .left-logo,
          .right-images{
            position:static;
          }

          .left-logo{
            margin-bottom:10px;
          }

          .left-logo img{
            width:70px;
          }

          .header-title h2{
            font-size:16px;
          }

          .iso-box h1{
            font-size:20px;
          }

          .iso-box img{
            width:60px;
          }

          .right-images{
            margin-top:15px;
            justify-content:center;
            flex-wrap:wrap;
          }

          .right-images img{
            width:55px;
            height:55px;
          }

          .menu-toggle{
            display:block;
          }

          .menuicons{
            display:none;
          }

          .menuicons.active{
            display:block;
          }

          .menuicons ul{
            flex-direction:column;
            gap:6px;
            padding:10px;
          }

          .menuicons ul li{
            width:100%;
            text-align:center;
          }

          .dropdown-menu{
            position:static;
            width:100%;
            box-shadow:none;
          }
        }
      `}</style>

      <header className="header">
        <div className="left-logo">
          <img
            src={`${process.env.PUBLIC_URL}/images/sj1.jpg`}
            alt="National Emblem"
          />
        </div>

        <div className="header-title">
          <h2>ग्रामपंचायत भालेवाडी</h2>
          <h2>पंचायत समिती कारंजा (घा), जिल्हा परिषद वर्धा</h2>
          <h2>महाराष्ट्रातील एकमेव ग्रामपंचायत उपक्रम</h2>

          <div className="iso-box">
            <h1>
              <u>9001:2015 Certified</u>
            </h1>

            <img
              src={`${process.env.PUBLIC_URL}/images/iso.png`}
              alt="ISO"
            />
          </div>
        </div>

        <div className="right-images">
          <img
            src={`${process.env.PUBLIC_URL}/images/raje.jpg`}
            alt=""
          />
          <img
            src={`${process.env.PUBLIC_URL}/images/Gadgemaharaj.jpg`}
            alt=""
          />
          <img
            src={`${process.env.PUBLIC_URL}/images/tujdojimaharaj.jpeg`}
            alt=""
          />
        </div>
      </header>

      <div className="style20">
        <div className="marquee">
          <p>
            ग्रामपंचायत भालेवाडी – तालुका कारंजा (घा) – जिल्हा वर्धा
          </p>
        </div>
      </div>

      {/* Hamburger Button */}
      <button
        className="menu-toggle"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        ☰
      </button>

      <nav className={`menuicons ${menuOpen ? "active" : ""}`}>
        <ul>
          <li><Link to="/aboutus">About Us</Link></li>
          <li><Link to="/">मुखपृष्ठ</Link></li>
          <li><Link to="/gramsevakpage">ग्रामपंचायत अधिकारी</Link></li>
          <li><Link to="/sarpanch">प्रशासक कार्यकाल</Link></li>
          <li><Link to="/gallery">Gallery</Link></li>
          <li><Link to="/vikas">विकास कामे</Link></li>
          <li><Link to="/sabha">सभेची माहिती</Link></li>

          <li className="dropdown">
            <span className="menu-link">दाखला ▾</span>
            <div className="dropdown-menu">
              <Link to="/janm-dakhala">जन्म दाखला</Link>
              <Link to="/death">मृत्यू दाखला</Link>
              <Link to="/vivah">विवाह दाखला</Link>
              <Link to="/namuna">नमूना 8</Link>
              <Link to="/namuna9">नमूना 9</Link>
              <Link to="/budget">अंदाज पत्रक </Link>

            </div>
          </li>

          <li><Link to="/rti-info">माहिती अधिकार 2005</Link></li>
         
          <li><Link to="/info">ग्रामपंचायत माहिती</Link></li>
          <li><Link to="/team">सदस्य</Link></li>
           <li><Link to="/contact">संपर्क करा</Link></li>
        </ul>
      </nav>
    </>
  );
};

export default Header;